import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Button, Col, Glyphicon, Modal, Row} from "react-bootstrap";
import {deleteParty} from '../actions/parties';
import {defaultState} from '../reducers/entity';
import PartyForm from '../components/party/PartyForm';
import {breadcrumbs} from "./../utils";
import {PartyRole, PartyStatus, PartyType, PartyVariant} from "../utils/enums";

class PartyEditPage extends Component {

	constructor(props) {
		super(props);

		this.handleDeleteParty = this.handleDeleteParty.bind(this);
		this.handleOpenDeleteClick = this.handleOpenDeleteClick.bind(this);
		this.handleDismissDeleteClick = this.handleDismissDeleteClick.bind(this);

		this.state = {
			isDeleteModalOpen: false,
			deleteParty: null
		}
	}

	handleOpenDeleteClick(party) {
		this.setState({isDeleteModalOpen: true, deleteParty: party})
	}

	handleDismissDeleteClick(e) {
		if (e) {
			e.preventDefault()
		}
		this.setState({isDeleteModalOpen: false, deleteParty: null})
	}

	handleDeleteParty(party) {
		return this.props.deleteParty(party.partyId).then((json) => {
			this.handleDismissDeleteClick();
			if (json && json.response && json.response.result === 'OK') {
				return new Promise((resolve, reject) => resolve(this.props.history.push('/vencitele')))
			}
		})
	}

	renderDeleteModal() {
		const {isDeleteModalOpen, deleteParty} = this.state;

		if (!isDeleteModalOpen) {
			return null
		}

		return (
			<Modal onHide={this.handleDismissClick} show={true}>
				<Modal.Header>
					<Modal.Title>Smazání osoby</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<p>Skutečně odstranit osobu <strong>{deleteParty.lastName}</strong>?</p>
				</Modal.Body>

				<Modal.Footer>
					<Row>
						<Col sm={12}>
							<Button onClick={this.handleDismissDeleteClick}>Storno</Button>
							<Button type="submit" onClick={() => this.handleDeleteParty(deleteParty)} bsStyle="danger">
								<Glyphicon glyph="trash"/> Smazat osobu</Button>
						</Col>
					</Row>
				</Modal.Footer>

			</Modal>
		)
	}

	render() {
		const {match: {params}, entity} = this.props;

		const party = {};
		if (params.partyId) {
			party.partyId = params.partyId;
		} else {
			party.partyType = PartyType.FO;
			party.partyRoles = [PartyRole.WALKER];
			party.status = PartyStatus.ACTIVE;
		}
		const bc = [
			{url: '/vencitele', title: 'Osoby'}
		];
		if (params.partyId) {
			bc.push({url: '/vencitele/' + params.partyId, title: entity && entity.item && entity.item.partyId ? entity.item.lastName + ' ' + entity.item.firstName : '...', literal: true});
			bc.push({url: '/vencitele/' + params.partyId + '/uprava', title: 'Úprava'});
		} else {
			bc.push({url: '/vencitele/novy', title: 'Nový'});
		}

		return (
			<div>
				<Row>
					<Col xs={12}>
						{breadcrumbs(bc)}
					</Col>
				</Row>
				<PartyForm
					variant={PartyVariant.WALKER}
					form={'party-' + PartyVariant.WALKER}
					party={party}
					modal={null}/>
				{this.renderDeleteModal()}
			</div>
		)
	}
}

PartyEditPage.propTypes = {
	entity: PropTypes.object.isRequired,
	deleteParty: PropTypes.func.isRequired,
	enums: PropTypes.object,
	session: PropTypes.object.isRequired,
};


const mapStateToProps = (state, ownProps) => {
	const {
		entities: {parties},
		enums,
		session
	} = state;

	const partyId = ownProps.match.params.partyId;
	const entity = partyId && parties[partyId]
		? parties[partyId]
		: Object.assign({}, defaultState);

	return {
		entity,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	deleteParty,
})(PartyEditPage)



// WEBPACK FOOTER //
// ./src/containers/PartyEditPage.js